import { render, staticRenderFns } from "./SearchResultRow.vue?vue&type=template&id=21ce525b&scoped=true"
import script from "./SearchResultRow.vue?vue&type=script&lang=ts"
export * from "./SearchResultRow.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultRow.vue?vue&type=style&index=0&id=21ce525b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce525b",
  null
  
)

export default component.exports